import {
    FETCH_ALL_TEAMS,
    FETCH_TEAM,
    CREATE_TEAM,
    DELETE_TEAM,
    ROOT_URL,
} from "./actions-index";
import axios from "axios/index";

export function receivedAllTeams(teamList) {
    return {
        type: FETCH_ALL_TEAMS,
        payload: teamList
    };
}

export function receivedTeam(team) {
    return {
        type: FETCH_TEAM,
        payload: team
    };
}

export function createdTeam(team) {
    return {
        type: CREATE_TEAM,
        payload: team
    };
}

export function deletedTeam(id) {
    return {
        type: DELETE_TEAM,
        payload: id
    };
}

export function fetchAllTeams() {
    return function (dispatch) {
        return axios.get(`${ROOT_URL}/team-list`)
            .then(response => {
                if (response) {
                    dispatch(receivedAllTeams(response.data));
                } else {
                    console.log('an error occurred while fetching /team-list');
                }
            });
    }
}

export function fetchTeam(teamId) {
    return function (dispatch) {
        return new Promise((resolve, reject) => {
            return axios.get(`${ROOT_URL}/team/${teamId}`)
                .then(response => {
                    if (response) {
                        resolve(dispatch(receivedTeam(response.data)));
                    } else {
                        console.log('an error occurred while fetching /team/' + teamId);
                    }
                });
        });
    }
}

export function createTeam(values) {
    return function (dispatch) {
        return new Promise((resolve, reject) => {
            axios.post(`${ROOT_URL}/team`, {
                id: values.id,
                teamName: values.teamName,
                owner: values.owner,
                description: values.description,
                imageURL: values.imageURL,
            }).then(response =>{
                if (response) {
                    resolve(dispatch(createdTeam(response.data)));
                } else {
                    console.log('an error occurred while creating /team');
                }
            });
        });
    }
}

export function deleteTeam(id) {
    return function (dispatch) {
        return new Promise((resolve, reject) => {
            axios.delete(`${ROOT_URL}/team/${id}`).then(response => {
                if (response) {
                    resolve(dispatch(deletedTeam(id)))
                } else {
                    console.log('an error occurred while deleting team');
                }
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/actions-team.js